export default "__VITE_ASSET__DjrmGtDR__"